import * as i0 from "@angular/core";
export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["WARNING"] = 2] = "WARNING";
    LogLevel[LogLevel["INFO"] = 3] = "INFO";
    LogLevel[LogLevel["LOG"] = 4] = "LOG";
    LogLevel[LogLevel["DEBUG"] = 5] = "DEBUG";
})(LogLevel || (LogLevel = {}));
/*
  Generated class for the LoggerService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
export class LoggerService {
    constructor() {
        this.logLevelByComponent = {};
        this.logLevelCss = {};
        this.logLevel = LogLevel.DEBUG;
        // Initalize log level colours.
        this.logLevelCss[LogLevel.ERROR] = 'color: #F00';
        this.logLevelCss[LogLevel.WARNING] = 'color: #F80';
        this.logLevelCss[LogLevel.INFO] = 'color: #0A0';
        this.logLevelCss[LogLevel.LOG] = 'color: #088';
        this.logLevelCss[LogLevel.DEBUG] = 'color: #AAA';
        window['logger'] = this;
    }
    isLoggable(msgLogLevel, component) {
        var rc;
        if (typeof (msgLogLevel) === 'undefined') {
            msgLogLevel = LogLevel.INFO;
        }
        if (typeof (this.logLevelByComponent[component]) !== 'undefined') {
            rc = this.logLevelByComponent[component] >= msgLogLevel;
        }
        else {
            rc = this.logLevel >= msgLogLevel;
        }
        return rc;
    }
    tryToLog(msgLogLevel, logLevelLabel, component, ...data) {
        if (this.isLoggable(msgLogLevel, component)) {
            this.doLog('%c[' + component + ' ' + logLevelLabel + ']', this.logLevelCss[msgLogLevel], ...data);
        }
    }
    doLog(label, ...data) {
        console.log(label, ...data);
    }
    setComponentLogLevel(component, newLogLevel) {
        this.logLevelByComponent[component] = newLogLevel;
    }
    error(component, ...data) {
        this.tryToLog(LogLevel.ERROR, 'ERROR', component, ...data);
    }
    warning(component, ...data) {
        this.tryToLog(LogLevel.WARNING, 'WARNING', component, ...data);
    }
    info(component, ...data) {
        this.tryToLog(LogLevel.INFO, 'INFO', component, ...data);
    }
    log(component, ...data) {
        this.tryToLog(LogLevel.LOG, 'LOG', component, ...data);
    }
    debug(component, ...data) {
        this.tryToLog(LogLevel.DEBUG, 'DEBUG', component, ...data);
    }
}
LoggerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoggerService_Factory() { return new LoggerService(); }, token: LoggerService, providedIn: "root" });
